import React from "react";

function ErrorMessage({ message }) {
  return <>{message && <p className="errorMessage">{message}</p>}</>;
}

export default ErrorMessage;
